import { useQuery } from "react-query";


import { getCompanies } from "../../../../../MyApi/hr/companies";

import LoadingSpinner from "../../../../UI/spinner";
import icons from "../../../../../Data/icons";

import classes from "./addEmpolyment.module.css";

const AddEmpolymentType = ({
  setName, setCompanyId, companyId, selectedOption,setSelectedOption, name, setDescription , description, setActive,active
  
}) => {
const {data , isLoading} = useQuery("getComapines" , getCompanies)



  const DollarSign = icons.Dollar;
  const Company = icons.company
  const Ab = icons.abc
  const handleNameChange = (e) => {
    setName(e.target.value);
  };
  const handleSelectedIdChange = (e) => {
    setCompanyId(e.target.options[e.target.selectedIndex].id);
    setSelectedOption(e.target.options[e.target.selectedIndex].text)
    
  }; 
  const handleDescChange =(e)=>{
  setDescription(e.target.value)
  }
  const handleActiveChange = (e)=>{
    const isChecked = e.target.checked
    if(isChecked){
      setActive(1)
    }else{
      setActive(0)
    }

  }
  if(isLoading){
    return <LoadingSpinner/>
  }
  const comapines =data?.data || []

  return (
    <div className={classes.formCard}>
      <div className={classes.formGrid}>
        <div className={classes.formCol}>
          <label htmlFor="">الاسم </label>
          <div className={classes.iconInput}>
            <Ab />
          </div>
          <input
            type="text"
            placeholder=" الاسم "
            onChange={handleNameChange}
            value={name}
            className={classes.inputCustom}
          />
              
        </div>
         <div className={classes.formCol}>
          <label htmlFor="">الوصف </label>
          <div className={classes.iconInput}>
            <Ab />
          </div>
          <input
            type="text"
            placeholder="ادخل  الوصف"
            onChange={handleDescChange}
            value={description}
            className={classes.inputCustom}
          />
        </div>

        
          {!data ? <div>no data available </div> :  
        <div className={classes.formCol}>
          <label htmlFor=""> الشركة</label>
          <div className={classes.iconInput}>
            <Company />
          </div>
          <select
            type="text"
            value={selectedOption}
            placeholder="اختار الشركة  "
            onChange={handleSelectedIdChange}
            className={classes.inputCustom}
          >
            <option  selected>اختار الشركة </option>
           { comapines.map((company)=>(
            <option key={company.id}    id={company.id} value={company.name} >{company.name}</option>
           ))}
         </select>
        </div> }
    
   
        
          <div className={classes.formCol}> 
           <label htmlFor="" className={active ? `${classes.active}` : `${classes.disActive}`}> {active==1 ?" نشط":"غير نشط"} </label>
         
          <label class="switch">
           <input type="checkbox" onChange={handleActiveChange} checked={active}/>
             <span class="slider round"></span>
         </label>   
        </div>
   
      
     
      </div>
    </div>
  );
};

export default AddEmpolymentType;
